import { render, staticRenderFns } from "./ProjectIssueList.vue?vue&type=template&id=4be2afe5&scoped=true&"
import script from "./ProjectIssueList.vue?vue&type=script&lang=js&"
export * from "./ProjectIssueList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectIssueList.vue?vue&type=style&index=0&id=4be2afe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be2afe5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VPagination,VProgressCircular,VTooltip})
